import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { ISolicitudEquipoAsignarDocumentoModel } from 'src/app/models/interfaces/solicitud/equipos/ISolicitudEquipoAsignarDocumentoModel';
import { ISolicitudEquipoValidarModel } from 'src/app/models/interfaces/solicitud/equipos/ISolicitudEquipoValidarModel';
import { ISolicitudEquipoModel } from 'src/app/models/interfaces/solicitud/ISolicitudEquipoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudEquipoService {

  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');

  constructor(private http: HttpClient) { }

  guardar(model: ISolicitudEquipoModel){
    return this.http.post<ISolicitudEquipoModel>(`${this.configUrl}/${model.idSolicitud}/equipos`, model);
  }

  asignardocumento(idSolicitud: number,model: ISolicitudEquipoAsignarDocumentoModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${idSolicitud}/equiposdocumento`, model);
  }

  getById(idSolicitud: number, idSolicitudEquipo: number): Observable<ISolicitudEquipoModel> {
    return this.http.get<ISolicitudEquipoModel>(`${this.configUrl}/${idSolicitud}/equipos/${idSolicitudEquipo}`);
  }

  validar(model: ISolicitudEquipoValidarModel){
    return this.http.post<ISolicitudEquipoValidarModel>(`${this.configUrl}/equipos/validar`, model);
  }

  eliminar(idSolicitudEquipo: number){
    return this.http.delete<ActionResultModel>(`${this.configUrl}/equipos/${idSolicitudEquipo}`);
  }
}
